export default "__VITE_ASSET__DjUuwXHV__"